module.exports = "/lucky-balls/img/color_betting/orange.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/color_betting/orange.png
// module id = 980
// module chunks = 0